import { Component } from "react";
import * as React from "react";
import { Link } from "react-router-dom";

interface IMenuItemProps {
    color: string;
    href: string;
    children: string;
}

export class MenuItem extends Component<IMenuItemProps> {
    public render() {
        const style = {
            color: this.props.color
        };

        return (
            <li><Link to={this.props.href} style={style}>{this.props.children.toUpperCase()}</Link></li>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/navigation/MenuItem.tsx